<ng-container *ngIf="!isLoadingDetails; else loadingAnimation">
    <div class="stock-warning">
        <app-message *ngIf="canRenderSampleBoardWarning()"
                     message="{{'admin.strain.registry.details.sampleBoardStockWarning' | translate}}"
                     severity="{{ MessageType.WARN }}">
        </app-message>
    </div>
    <div class="tools-warning" *ngIf="canRenderToolsWarning()">
        <app-message message="{{'admin.strain.registry.details.toolsWarning' | translate}}"
                     severity="{{ MessageType.WARN }}">
        </app-message>
    </div>
    <div class="max-value-warning" *ngIf="canRenderMaxValueWarning()">
        <app-message message="{{'admin.strain.registry.details.maxValueWarning' | translate}}"
                     severity="{{ MessageType.WARN }}">
        </app-message>
    </div>
    <div class="configuration">
        <p class="title">{{ 'admin.strain.registry.details.configuration' | translate }}</p>
        <div class="details-grid">
            <app-label flow="inline"
                       name="{{'admin.strain.registry.details.family' | translate}}"
                       value="{{entry?.partNumber?.sapFamily}}">
            </app-label>
            <app-label flow="inline"
                       name="{{'admin.strain.registry.details.partNumber' | translate}}"
                       value="{{entry?.partNumber?.name}}">
            </app-label>
            <div [ngClass]="getBomStatusStyle(entry?.partNumber?.bomStatus)">
                <app-label flow="inline"
                           name="{{'admin.strain.registry.details.bomStatus' | translate}}"
                           value="{{entry?.partNumber?.bomStatus}}">
                </app-label>
            </div>
            <app-label flow="inline"
                       name="{{'admin.strain.registry.details.equipment' | translate}}"
                       value="{{entry?.equipment?.name}}">
            </app-label>
            <app-label flow="inline"
                       name="{{'admin.strain.registry.details.equipmentType' | translate}}"
                       value="{{entry?.equipmentType}}">
            </app-label>
            <app-label flow="inline"
                       name="{{'admin.strain.registry.details.line' | translate}}"
                       value="{{entry?.line?.name}}">
            </app-label>
            <app-label flow="inline"
                       name="{{'admin.strain.registry.details.process' | translate}}"
                       value="{{entry?.process?.name}}">
            </app-label>
            <app-label flow="inline"
                       name="{{'admin.strain.registry.details.riskClass' | translate}}"
                       value="{{entry?.riskClass?.name}}">
            </app-label>
            <app-label flow="inline"
                       name="{{'admin.strain.registry.details.clientAcceptedLimit' | translate}}"
                       value="{{entry?.limitAcceptedByClient}}">
            </app-label>
            <app-label flow="inline"
                       name="{{'admin.strain.registry.details.destructiveProcess' | translate}}"
                       value="{{entry?.process?.isDestructive ? 'generic.yes' : 'generic.no' | translate}}">
            </app-label>
        </div>
    </div>

    <div class="stock" *ngIf="showStock">
        <p class="title with-action">
            <span>{{ 'admin.strain.planning.details.stock' | translate }}</span>
            <a class="summary-action waves-effect btn-flat"
               (click)="openSampleBoardsModal($event)"
               pTooltip="{{ 'admin.strain.registry.details.openSampleBoards' | translate }}">
                <i class="material-icons">open_in_new</i>
            </a>
        </p>
        <div class="stock-summary">
                    <span>{{ 'admin.strain.registry.details.requiredSamples' | translate }}
                        : {{ requiredSampleBoardsCount }}</span>
            <span>{{ 'admin.strain.registry.details.spareSamples' | translate }}
                : {{ spareSampleBoardsCount }}</span>
            <span>{{ 'admin.strain.registry.details.totalSamples' | translate }}
                : {{ availableSampleBoardsCount }}</span>
        </div>
        <div class="stock-list">
            <ng-container *ngIf="stockItems?.length; else noStock">
                <app-sample-board-stoc-list-item
                    *ngFor="let stock of stockItems"
                    [item]="stock">
                </app-sample-board-stoc-list-item>
            </ng-container>
            <ng-template #noStock>
                <div class="empty-stock">
                    {{ 'admin.strain.planning.details.noStock' | translate }}
                </div>
            </ng-template>
        </div>
    </div>
    <div class="tools">
        <p class="title">{{ 'admin.strain.registry.details.tools' | translate }}</p>
        <app-tool-scan-tree *ngIf="entry?.hasTools else toolInfo"
                            [isMaterial]="false"
                            [loading]="isLoadingTools"
                            mode="display"
                            [items]="tools">
        </app-tool-scan-tree>
        <ng-template #toolInfo><span>{{ entry?.toolInfo ? entry?.toolInfo : 'N/A' }}</span></ng-template>
    </div>
    <div class="codes">
        <p class="title">{{ 'admin.strain.registry.details.codes' | translate }}</p>
        <app-listbox [items]="entry?.codes"
                     [isMaterial]="false"
                     [emptyMessage]="'admin.strain.registry.details.noCodes' | translate">
            <ng-template #custom let-code>
                {{ code?.name }} - {{ code?.code }}
            </ng-template>
        </app-listbox>
    </div>
    <div class="equivalent">
        <p class="title with-action">
            <span>{{ 'admin.strain.registry.details.equivalent' | translate }}</span>
            <a *ngIf="canEditEquivalent"
               class="summary-action waves-effect btn-flat"
               (click)="openEquivalentPartNumbersModal($event)"
               pTooltip="{{ 'admin.strain.registry.details.equivalentModal.editTooltip' | translate }}">
                <i class="material-icons">edit</i>
            </a>
            <a *ngIf="canUpdateMainPartNumber()"
               class="summary-action waves-effect btn-flat"
               (click)="openUpdateMainPartNumberModal($event)"
               pTooltip="{{ 'admin.strain.registry.details.updateMainPartNumber' | translate }}">
                <i class="material-icons">swap_horiz</i>
            </a>
        </p>
        <div class="equivalent-list">
            <app-listbox [items]="entry?.partNumber?.strainEquivalentPartNumbers"
                         [isMaterial]="false"
                         [emptyMessage]="'admin.strain.registry.details.noPNEquivalent' | translate">
                <ng-template #custom let-partNumber>
                    {{ partNumber?.name }} - {{ partNumber?.bomStatus || 'N/A' }}
                </ng-template>
            </app-listbox>
        </div>
    </div>
    <div class="participants" *ngIf="showParticipants">
        <p class="title">{{ 'admin.strain.tickets.details.participants' | translate }}</p>
        <app-listbox [items]="participants"
                     [isMaterial]="false"
                     [emptyMessage]="'admin.strain.tickets.details.participantsEmpty' | translate">
            <ng-template #custom let-participant>
                {{ participant?.name || participant?.fullName || (participant?.firstName + ' ' + participant?.lastName) }}
            </ng-template>
        </app-listbox>
    </div>
</ng-container>

<app-modal #sampleBoardsModal
           [dismissible]="true"
           [autoZIndex]="true"
           [baseZIndex]="10000">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.strain.registry.details.sampleBoardsModal.title' | translate }}</h5>
    </ng-container>
    <ng-container modal-body>
        <app-sample-board-registry-items
            [itemType]="'sampleBoard'"
            [items]="sampleBoards"
            [isLoading]="isLoadingDetails"
            [headerTitle]="'admin.strain.registry.details.sampleBoardsModal.headerTitle' | translate"
            [headerSubtitle]="'admin.strain.registry.details.sampleBoardsModal.headerSubtitle' | translate: { count: sampleBoards?.length || 0 }"
            [emptyText]="'admin.strain.registry.details.sampleBoardsModal.empty' | translate"
            (openRegistry)="onOpenSampleBoard($event)">
        </app-sample-board-registry-items>
    </ng-container>
    <div class="modal-footer" modal-footer>
        <app-button type="simple" (click)="closeSampleBoardsModal()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>
    </div>
</app-modal>

<app-strain-equivalent-part-numbers-modal
    #equivalentPartNumbersModal
    [partNumbers]="strainEquivalentPartNumbers"
    [selectedPartNumber]="entry?.partNumber"
    [equivalentPartNumbers]="entry?.partNumber?.strainEquivalentPartNumbers"
    [isUpdateInProgress]="isEquivalentUpdateInProgress"
    (save)="onSaveEquivalentPartNumbers($event)">
</app-strain-equivalent-part-numbers-modal>

<app-strain-update-main-part-number-modal
    #updateMainPartNumberModal
    [currentPartNumber]="entry?.partNumber"
    [equivalentPartNumbers]="entry?.partNumber?.strainEquivalentPartNumbers"
    [isUpdateInProgress]="isEquivalentUpdateInProgress"
    (save)="onSaveMainPartNumber($event)">
</app-strain-update-main-part-number-modal>

<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
